<!--
 * @Description: 用户下拉菜单
 * @Author: shangao
 * @Date: 2022-04-28 09:50:27
 * @LastEditTime: 2022-04-28 10:17:05
 * @LastEditors: shangao
 * @FilePath: \teaching-web\src\layouts\AvatarDropdown.vue
-->
<template>
  <div class="avatar-dropdown"> 
    <el-dropdown v-if="loginStatus" @command="handleCommand">
      <div class="user">
        <el-avatar :src="userInfo.photo.replace('http://', 'https://')"></el-avatar>
        <div class="username" :title="userInfo.userName">
          {{ userInfo.userName }}
        </div>
        <!-- <i class="el-icon-caret-bottom"></i> -->
        <i class="login-area-arrow" style="display: block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 4px 3.5px 0;
    border-color: #8c8c8c transparent transparent;
    -webkit-transition: all .3s;
    -o-transition: all .3s;
    transition: all .3s;"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <a v-else :href="VUE_APP_LOGINREDIRECTURL" target="_blank">登录/注册</a>
  </div>
</template>
<script>
import { mapState } from 'vuex'
const {
  VUE_APP_LOGINREDIRECTURL
} = process.env
export default {
  name: 'AvatarDropdown',
  data () {
    return {
      VUE_APP_LOGINREDIRECTURL
    }
  },
  computed: {
    ...mapState({
      loginStatus: state => state.loginStatus,
      userInfo: state => state.userInfo
    }),
  },
  methods: {
    handleCommand (command) {
      if (command === 'logout') {
        this.$store.dispatch('Logout')
        this.$router.go(0)
      }
    }
  }
}
</script>
<style lang="less">
.avatar-dropdown {
  .user {
    display: flex;
    align-items: center;
  }
  .el-avatar {
    margin-right: 6px;
  }
  .username {
    cursor: pointer;
    overflow: hidden;
    width: 68px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  a {
    color: #409eff;
  }
}
</style>